import { render } from "./TradeCardGP.vue?vue&type=template&id=7786bb7e&scoped=true&ts=true"
import script from "./TradeCardGP.vue?vue&type=script&lang=ts"
export * from "./TradeCardGP.vue?vue&type=script&lang=ts"

import "./TradeCardGP.vue?vue&type=style&index=0&id=7786bb7e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7786bb7e"]])

export default __exports__